import { render, staticRenderFns } from "./ProyectosDetalle.vue?vue&type=template&id=9d24ffdc"
import script from "./ProyectosDetalle.vue?vue&type=script&lang=js"
export * from "./ProyectosDetalle.vue?vue&type=script&lang=js"
import style0 from "./ProyectosDetalle.vue?vue&type=style&index=0&id=9d24ffdc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports